import React, { createContext, useContext, useState } from 'react';
import { BookingForm } from '../components/BookingForm';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const openBooking = () => setIsBookingOpen(true);
  const closeBooking = () => setIsBookingOpen(false);

  return (
    <BookingContext.Provider value={{ isBookingOpen, openBooking, closeBooking }}>
      {children}
      <BookingForm isOpen={isBookingOpen} onClose={setIsBookingOpen} />
    </BookingContext.Provider>
  );
};
